import moment from 'moment'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { getDeveloperById } from '../../redux/Action/DeveloperAction'
import { DEVELOPER_GET_BY_ID } from '../../redux/type'
import Loading from '../../layout/Loading'

const ViewDeveloper = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const [developerData, setDeveloperData] = useState()
    const gateByIdDeveloperppData = useSelector(state => state.developeraccount.getbyiddeveloper)
    const loading = useSelector(state => state.developeraccount.loading)

    useEffect(() => {
        if (id) {
            dispatch(getDeveloperById(id))
        }
    }, [id])

    useEffect(() => {
        return () => {
            dispatch({
                type: DEVELOPER_GET_BY_ID,
                payload: ''
            })
        }
    }, [])


    useEffect(() => {
        if (gateByIdDeveloperppData) {
            setDeveloperData(Object.keys(gateByIdDeveloperppData).filter(ele => !['_id', '__v', 'isDeleted', 'application'].includes(ele)).map(key => {
                if (['createdAt', 'updatedAt'].includes(key)) {
                    return ({ key: key, value: moment(gateByIdDeveloperppData[key]).format('DD.MM.YYYY') })
                }
                if (gateByIdDeveloperppData[key] && typeof gateByIdDeveloperppData[key] === "object") {
                    return Object.keys(gateByIdDeveloperppData[key]).filter(ele => !['_id', '__v', 'isDeleted'].includes(ele)).map(key_ele => {
                        return ({ key: `${key}`, value: gateByIdDeveloperppData[key][key_ele] })
                    })
                } else {
                    return ({ key: key, value: gateByIdDeveloperppData[key] })
                }
            }).flat(1))
        }
    }, [gateByIdDeveloperppData])

    return (
        <>
            {loading ? <Loading /> : (
                <div className='android-main'>
                    <div className='android-main-card p-0'>
                        <div className='card__header'>
                            <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <h1 className='title'>
                                    {gateByIdDeveloperppData?.consoleName}
                                </h1>
                            </div>
                            <div className='header_buttons'>
                                <Button className='header_cancel_button' onClick={() => navigate(`/edit-developer/${id}`)}>Edit</Button>
                                <Button className='header_cancel_button' onClick={() => navigate('/developer-account')}>Back</Button>
                            </div>
                        </div>
                        <table className='view_table'>
                            <tbody style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {
                                    developerData && developerData.map((item) => {
                                        return (
                                            <tr style={{ width: '50%', display: 'flex', justifyContent: 'space-around' }}>
                                                <td>{item.key}</td>
                                                <td>
                                                    {item.value}
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                                <tr style={{ width: '50%', display: 'flex', justifyContent: 'space-around' }}>
                                    <td>Apps</td>
                                    <td>
                                        {gateByIdDeveloperppData && gateByIdDeveloperppData.application && gateByIdDeveloperppData.application.map(app => (
                                            <a style={{ marginRight: '10px' }} href={app.appLink} target="_blank">
                                                <img className='app_logo' src={app.logo} alt='logo' />
                                            </a>
                                        ))}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    )
}

export default ViewDeveloper